import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LikeTwoToneSvg from "@ant-design/icons-svg/es/asn/LikeTwoTone";
import AntdIcon from '../components/AntdIcon';
var LikeTwoTone = function LikeTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: LikeTwoToneSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(LikeTwoTone);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'LikeTwoTone';
}
export default RefIcon;